var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialYoutubeMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "YouTube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.4 9.6 4.16 2.4-4.16 2.4V9.6ZM24 6v12c0 3.31-2.69 6-6 6H6c-3.31 0-6-2.69-6-6V6c0-3.31 2.69-6 6-6h12c3.31 0 6 2.69 6 6Zm-4 6s0-2.6-.33-3.85a1.99 1.99 0 0 0-1.41-1.41c-1.25-.33-6.25-.33-6.25-.33s-5 0-6.25.33c-.69.18-1.23.73-1.41 1.41C4.02 9.4 4.02 12 4.02 12s0 2.6.33 3.85c.18.69.73 1.23 1.41 1.41 1.25.33 6.25.33 6.25.33s5 0 6.25-.33a1.99 1.99 0 0 0 1.41-1.41C20 14.6 20 12 20 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutubeMono);
export default __webpack_public_path__ + "static/media/social-youtube-mono.85e41f95aaf067395a2575b0b0fd1ac0.svg";
export { ForwardRef as ReactComponent };